import Button from '@ergeon/core-components/exports/Button.ts';

interface LobbyJoinButtonProps {
  currentMeetingUrl: string | null;
  isCancelled: boolean;
  isClient: boolean;
  onJoin(): void;
}

const joinTextFor = (isClient: boolean, isCancelled: boolean) => {
  if (!isClient) {
    return 'Join call';
  }

  return isCancelled ? 'Join anyway & Consent' : 'Join & Consent';
};

export default function LobbyJoinButton({
  currentMeetingUrl, isCancelled, isClient, onJoin,
}: LobbyJoinButtonProps) {
  // With a next visit to go to, joining this one is the fallback, not the call
  // to action.
  const hasNextVisit = isClient && isCancelled && Boolean(currentMeetingUrl);
  const joinFlavor = hasNextVisit ? 'regular' : 'primary';
  const joinTaste = hasNextVisit ? 'line' : 'solid';

  return (
    <Button
      flavor={joinFlavor} isFullWidth onClick={onJoin} size="large"
      taste={joinTaste}>
      {joinTextFor(isClient, isCancelled)}
    </Button>
  );
}
